import styles from './styles.module.scss';

export const LocationDetails = (props) => {
  const { PropertyTransaction } = props;
  const Property = PropertyTransaction?.Property;

  return (
    <div>
      <div className={styles.locationDetails}>
        <p className={styles.locationName}>{`${Property?.Address?.Line1} ${
          Property?.Address?.Line2 ? `#${Property?.Address?.Line2}` : ''
        }`}</p>

        <p className={styles.locationAddress}>
          {Property?.Address?.City + ', ' + Property?.Address?.State + ' ' + Property?.Address?.Zip}
        </p>
      </div>
    </div>
  );
};
